export default function noop(...args: any[]): void {
  /** noop function */
}
